import 'ui-core/plugins/drawer/js/drawer';
(function () {
    let st = 0;
    const ads = document.querySelectorAll('.header-ad');
    const navToggle = $('a[data-target="main-menu"]');

    // on the initial load - befor any scroll occures - the manu will take place before the ad contend load, when the ad loads, it will push the navbar downword, leaving the menu on top, but this solves the issue.
    UX.menu.observeAdHeightChange = (() => {
        const onAdHeightChange = entries => entries.forEach(UX.menu.adjustNav);
        const resizeObserver = new ResizeObserver(onAdHeightChange);
        ads.forEach(adContainer => resizeObserver.observe(adContainer));
    })();

    UX.menu.adjustNav = function () {
        let adHeight = 0;
        ads && ads.length && ads.forEach(ad => (adHeight += ad.offsetHeight));
        const topValue = navToggle.hasClass('js--open') ? st : adHeight - st > 0 ? adHeight - st : 0;
        $('.main-nav').css('top', topValue);
    };

    UX.menu.on.hide = function () {
        var $body = $('body');
        if (UX.menu.isMobile) {
            // hide nested menu before closing
            UX.menu.on.hideNested();
        }
        UX.menu.$toggle.removeClass('js--open');
        UX.menu.on.showNestedExtra();
        $('.coolBar--res').addClass('trans').css('top', $('header').height()); // The magic number contains 1px of border and
        $('.loi__banner.loi--res').css('top', $('header').height());
        $body.removeAttr('data-active').removeClass('lock-screen');
        $('.main-nav__toggle__controller').attr('aria-expanded', 'false');
        UX.menu.on.listPosition.reset();
        UX.menu.adjustNav();
    };
    UX.menu.on.showNestedExtra = function () {
        if ($('.header-ad').length) {
            UX.menu.adjustNav();
        }
    };

    window.addEventListener(
        'scroll',
        function () {
            st = window.pageYOffset || document.documentElement.scrollTop;
            UX.menu.adjustNav();
            if (st === 0) {
                UX.menu.on.showNestedExtra();
            }
        },
        false
    );
})();
